import * as React from 'react';
export var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
export var IconContext = React.createContext && React.createContext(DefaultContext);


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-icons/lib/esm/iconContext.js
// module id = null
// module chunks = 